import { OdataManager } from '@/api/odata/odata-manager';
import { PackageKS2IssueComment } from '@/api/model/interfaces';

export default class PackageKS2IssueCommentOdata extends OdataManager<PackageKS2IssueComment> {}
